import { render } from "./DataCard.vue?vue&type=template&id=aa9d6822&ts=true"
import script from "./DataCard.vue?vue&type=script&lang=ts"
export * from "./DataCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__